import lf from 'lovefield'

export function simu_echelons (schemaBuilder) {
  schemaBuilder.createTable('simu_echelons')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('ordre', lf.Type.INTEGER)
      /*.addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('exo_mouvements_id', lf.Type.INTEGER)*/
      .addColumn('simu_mouvements_id', lf.Type.INTEGER)
      .addColumn('rendement', lf.Type.INTEGER)
      .addColumn('cout', lf.Type.INTEGER)
      .addColumn('homme', lf.Type.INTEGER)
      
      .addPrimaryKey(['id'], true) // true == autoincrement ?
      .addNullable(['ordre', 'simu_mouvements_id', 'rendement', 'cout', 'homme'])
      // .addIndex('eleves_id', ['simuEtudes_id']);
      // .addIndex('exoMouvements_id', ['exoMouvements_id']);

}

/*
CREATE TABLE IF NOT EXISTS `simu-echelons` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `ordre` tinyint(4) NOT NULL,
  `simu-etudes_id` int(11) NOT NULL,
  `exo-mouvements_id` int(11) NOT NULL,
  `rendement` int(11) NOT NULL,
  `cout` int(11) NOT NULL,
  `homme` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  KEY `eleves_id` (`simu-etudes_id`),
  KEY `exo-mouvements_id` (`exo-mouvements_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEchelons.schema.js